/**
 * Logger Utility
 * 
 * Environment-based logging utility
 * - Development: Logs everything
 * - Production: Only logs errors
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Debug logs - only in development
   */
  debug: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Info logs - only in development
   */
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Warning logs - only in development
   */
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Error logs - always logged (even in production)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },
};
